import { AnimatedSection } from "@/components/shared/AnimatedSection";

export const ProcessSteps = ({ steps }) => (
  <div>
    <div className="hidden lg:flex items-start justify-between gap-6">
      {steps.map((step, i) => (
        <AnimatedSection
          key={step.title}
          delay={i * 0.1}
          data-testid={`process-step-${i + 1}`}
          className="flex-1"
        >
          <div className="flex items-center gap-3 mb-4">
            <span className="font-heading text-2xl text-accent">{String(i + 1).padStart(2, "0")}</span>
            {i !== steps.length - 1 && <span className="h-px flex-1 bg-navy/15" />}
          </div>
          <h4 className="font-heading text-base font-semibold text-navy mb-2">{step.title}</h4>
          <p className="text-sm text-slate leading-relaxed">{step.description}</p>
        </AnimatedSection>
      ))}
    </div>
    <div className="lg:hidden space-y-8">
      {steps.map((step, i) => (
        <AnimatedSection
          key={step.title}
          delay={i * 0.05}
          data-testid={`process-step-mobile-${i + 1}`}
          className="flex gap-5"
        >
          <span className="font-heading text-2xl text-accent flex-shrink-0">{String(i + 1).padStart(2, "0")}</span>
          <div>
            <h4 className="font-heading text-base font-semibold text-navy mb-2">{step.title}</h4>
            <p className="text-sm text-slate leading-relaxed">{step.description}</p>
          </div>
        </AnimatedSection>
      ))}
    </div>
  </div>
);
